module.exports = __webpack_public_path__ + "img/arrow-up-circle.c7e27cfe.svg";